export const getType = obj => Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
export const isArray = obj => getType(obj) === "array";
export const isObject = obj => getType(obj) === "object";
export const isFunction = obj => getType(obj) === "function";